import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import AdditionalFormLayout from './AdditionalFormLayout';

function AdditionalTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [forceRender, setForceRender] = useState(false);
    const LoadLookupStaticData = (name, data) => {
        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current[name]) {
                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
                setForceRender(!forceRender);
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const LoadLookukpData = (name, url, valueExpr, displayExpr) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                key: valueExpr,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            console.log('found control:');
            formRefs.current[name].instance().option('dataSource', items);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            setForceRender(!forceRender);
        } else {
            console.log('not found control:');
        }
    };
    const loadLookupFromDataSourceName = (name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'name');
            formRefs.current[name].instance().option('displayExpr', 'name');
        }
        else {
            console.log('not found control:');
        }
    };
    const AdditionalFormLoad = useCallback(() => {
        // valueExpr is 'name', not 'id'. GetHoldReasons projects Id = WMCODES.ROWID (a Guid) and
        // Name = WMCODES.CODE, while WMTRANSACTIONHEADER.HOLDREASON is varchar(10) — binding 'id' stored
        // a 36-character Guid into it, so picking any hold reason truncated or failed on save. The
        // AVAILABLEREASONCODE lookup below already pins its valueExpr to 'name' for the same reason.
        LoadLookukpData("HOLDREASON", "wm/Lookup/GetHoldReasons", 'name', 'name');
        var transactionFreightChargeTypes = [
            { "Rowid": "B", "Code": "Bill Third Party" },
            { "Rowid": "C", "Code": "Collect - Shipment Transactions Only" },
            { "Rowid": "N", "Code": "None" },
            { "Rowid": "P", "Code": "Prepaid" },
        ];
        LoadLookupStaticData("FREIGHTCHARGETYPE", transactionFreightChargeTypes);
        LoadLookukpData("R_FREIGHTBILLTO", "wm/Transaction/GetCustomers", 'id', 'name');
        var ediStatus = [
            { "Rowid": "A", "Code": "Accepted" },
            { "Rowid": "N", "Code": "No" },
            { "Rowid": "R", "Code": "Rejected" },
            { "Rowid": "Y", "Code": "Yes" },
            { "Rowid": "S", "Code": "Sent" },
        ];
        LoadLookupStaticData("EDITRANSMIT_CARRIER", ediStatus);
        LoadLookupStaticData("EDITRANSMIT_CUSTOMER", ediStatus);
        LoadLookupStaticData("EDITRANSMIT_CONSIGNEE", ediStatus);
        LoadLookupStaticData("EDITRANSMIT_SHIPPER", ediStatus);
        LoadLookukpData("RFGROUP", "wm/Lookup/GetRFGroups", 'name', 'name');
        var yesNoOptions = [
            { "Rowid": "N", "Code": "No" },
            { "Rowid": "Y", "Code": "Yes" },
        ];
        LoadLookupStaticData("RECEIPTPUTONHOLD", yesNoOptions);
        LoadLookukpData("R_GLDEPARTMENT", "ac/Lookup/GetDepartments", 'id', 'name');
        var availableReasonCodeDataSource = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return "02";
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("AVAILABLEREASONCODE", availableReasonCodeDataSource);
        LoadLookukpData("R_GLFUND", "fa/Lookup/GetFafunds", 'id', 'name');
        LoadLookukpData("R_CAJOB", "ca/Lookup/GetCaJobs", 'id', 'name');
        var PrintOptions = [
            { "Rowid": "N", "Code": "No" },
            { "Rowid": "Y", "Code": "Yes" },
            { "Rowid": "P", "Code": "Printed" },
        ];
        LoadLookupStaticData("PRINTRECEIPT", PrintOptions);
        LoadLookupStaticData("PRINTBOL", PrintOptions);
        LoadLookupStaticData("PRINTPICKINGSLIP", PrintOptions);
        LoadLookupStaticData("SENDFAX", yesNoOptions);
        LoadLookupStaticData("PRINTSERIALNUMBERMANIFEST", PrintOptions);
        LoadLookupStaticData("PRINTRECEIPTPUTAWAY", PrintOptions);
        var RFTransactionOptions = [
            { "Rowid": "M", "Code": "Master Order" },
            { "Rowid": "N", "Code": "Not Used With RF/Handheld" },
            { "Rowid": "C", "Code": "Currently Being Processed By RF/Handheld" },
            { "Rowid": "T", "Code": "Tasks Created for Transaction" },
            { "Rowid": "Z", "Code": "RF Processing Completed" },
        ];
        LoadLookupStaticData("RFTRANSACTION", RFTransactionOptions);
        if (props.formFields.FREIGHTCHARGETYPE != "N") {
            if (formRefs.current['FREIGHTAMOUNT']) {
                formRefs.current['FREIGHTAMOUNT'].instance().option('disabled', false);
            }
        }
        else if (props.formFields.FREIGHTCHARGETYPE == "N") {
            if (formRefs.current['FREIGHTAMOUNT']) {
                formRefs.current['FREIGHTAMOUNT'].instance().option('disabled', true);
            }
        }
        if (props.formFields.FREIGHTCHARGETYPE != "B") {
            if (formRefs.current['R_FREIGHTBILLTO']) {
                formRefs.current['R_FREIGHTBILLTO'].instance().option('disabled', true);
            }
           
        }
        else if (props.formFields.FREIGHTCHARGETYPE == "B") {
            if (formRefs.current['R_FREIGHTBILLTO']) {
                formRefs.current['R_FREIGHTBILLTO'].instance().option('disabled', false);
            }
            if (formRefs.current['FREIGHTAMOUNT']) {
                formRefs.current['FREIGHTAMOUNT'].instance().option('disabled', false);
            }
        }
        formRefs.current['PRINTBOL'].instance().option('disabled', true);
        formRefs.current['PRINTPICKINGSLIP'].instance().option('disabled', true);
        setForceRender(!forceRender);

        if(props.isCommittedTransaction){
            if (formRefs.current) {
                Object.keys(formRefs.current).forEach((key) => {
                    //if (key === "REFERENCE" || key === "COMMENT") return;
                    const instance = formRefs.current[key]?.instance;
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                });
            }
        }


    }, []);
    const handleFieldChange = useCallback((name, value, e) => {
        if (name == 'FREIGHTCHARGETYPE' && value != "N") {
            if (formRefs.current['FREIGHTAMOUNT']) {
                formRefs.current['FREIGHTAMOUNT'].instance().option('disabled', false);
            }
        }
        else if (name == 'FREIGHTCHARGETYPE' && value == "N") {
            if (formRefs.current['FREIGHTAMOUNT']) {
                formRefs.current['FREIGHTAMOUNT'].instance().option('disabled', true);
            }
        }
        if (name == 'FREIGHTCHARGETYPE' && value != "B") {
            if (formRefs.current['R_FREIGHTBILLTO']) {
                formRefs.current['R_FREIGHTBILLTO'].instance().option('disabled', true);
            }
           
        }
        else if (name == 'FREIGHTCHARGETYPE' && value == "B") {
            if (formRefs.current['R_FREIGHTBILLTO']) {
                formRefs.current['R_FREIGHTBILLTO'].instance().option('disabled', false);
            }
            if (formRefs.current['FREIGHTAMOUNT']) {
                formRefs.current['FREIGHTAMOUNT'].instance().option('disabled', false);
            }
        }
    }, []);

    const handleSelectionChange = useCallback((name, e) => {
    }, []);

    return (
        <div><FormField
            currrentUser={currentUser}
            layoutId='F1E9B642-BF91-4089-8C45-E8C98FB88B5F'
            layoutName='MyTestForm'
            defaultFormSchema={AdditionalFormLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
            onFormLoad={AdditionalFormLoad}
            noSpacingBeforeFirstRow={true}
        /></div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdditionalTab);